import { GetterTree } from "vuex";
import PropertyStoreTypes from "./define-types.store";
import {
	ReportSendEmailModel,
	SendEmailLookupInfosDto
} from "../../../models/report";
import { ISendMessageState } from "./states.store";
const descriptionGetters: GetterTree<ISendMessageState, {}> = <GetterTree<
	ISendMessageState,
	{}
	>>{
		service: (state: ISendMessageState) => state.service,

		/** GET ALL CURRENT SEND EMAIL MODEL */
		[PropertyStoreTypes.Get.GET_SENDEMAIL]: (state: ISendMessageState) => {
			let model = state.sendEmail || new ReportSendEmailModel();
			if (model.LookupInfos == null)
				model.LookupInfos = new SendEmailLookupInfosDto();
			return model;
  },
    
		/** GET DEMAND INFO */
		[PropertyStoreTypes.Get.DEMAND_INFOS]: (state: ISendMessageState) => {
			return state.demandInfos || [];
		},
		/** GET PERSON INFO */
		[PropertyStoreTypes.Get.PERSON_INFOS]: (state: ISendMessageState) => {
			return state.personInfos || [];
		},

		/** GET DESINGED TEMPLATE TOKEN */
		[PropertyStoreTypes.Get.DESINGED_MESSAGE_TEMPLATES]: (state: ISendMessageState) => {
			return state.designedMessageTemplates || [];
		},
	};

export default descriptionGetters;
